module.exports = __webpack_public_path__ + "static/media/tag.5089dbef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tag.svg
// module id = 1548
// module chunks = 0